import React from 'react';
import { Box, Modal, Typography } from '@mui/material';
import { uploadType } from '../../Constants';
import FileManager from './FileManager';
import { Upload } from '../../@types/api';

const style = {
  height: '90%',
  width: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  ml: '10%',
  mr: '10%',
  mt: '2%',
};

interface CustomModalProps {
  show: boolean;
  handleClose: () => void;
  fileType: number;
  handleUploadSelect: (file: Upload) => void;
}

const ModalFileManager: React.FC<CustomModalProps> = ({
  show,
  handleClose,
  fileType,
  handleUploadSelect,
}) => {
  return (
    <Modal open={show} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          height: fileType === uploadType.blog ? '200px' : '90%',
          overflowY: fileType === uploadType.blog ? 'hidden' : 'scroll',
        }}
      >
        <Typography variant='h5' mb={3}>
          File Manager
        </Typography>
        <FileManager
          isModal
          handleUploadSelect={handleUploadSelect}
          fileTypeId={fileType}
        />
      </Box>
    </Modal>
  );
};

export default ModalFileManager;
